import searchClient from '../repositories/searchClient'
import { getCourseIndex } from '../../getIndexNames'

export default function getCourses() {
  let hits = []
  const index = searchClient.initIndex(getCourseIndex())
  return index
    .browseObjects({
      batch: (batch) => {
        hits = hits.concat(batch)
      },
    })
    .then(() => [...hits])
}
